import EventBus, { EventName } from "../../../Shared/Assets/event-bus";
import UserDataService from "../../../Shared/Assets/userdata-service";
import {
  empty,
  initPopover,
  sendGAEvent
} from "../../../Shared/Assets/utils";

export default class SellerPhoneNumber {
  constructor() {
    this.eventBus = new EventBus();
  }

  init(formElement) {
    this.form = formElement;
    if (this.form.getAttribute("data-init") === "1") return false;
    this.form.setAttribute("data-init", "1");

    this.form.addEventListener("submit", this._handleSubmission);
    initPopover();
    this._setupEventListener();
  }

  _handleSubmission = evt => {
    evt.preventDefault();

    let form = evt.target;
    let submitButton = form.btnViewSellerPhoneNumber;
    let networkId = form.NetworkId.value;
    let verificationData = {
        BlockoInfo: this._getBlockoInfo(),
        SherlockoFingerprint: window.fingerprint || '',
        ForcedVerdict: window.forced_verdict || ''
    };

    submitButton.classList.add("loading");
    submitButton.disabled = true;

    let url = form.action;
    $.ajax({
      url: url,
      type: "POST",
      data: {
        NetworkId: networkId,
        Data: verificationData
      },
      success: response => {
        submitButton.classList.remove("loading");
        submitButton.disabled = false;

        this.eventBus.dispatch(EventName.VerifyPhoneNumberResponded, response);

        if (!empty(response.userData)) {
          let userDataService = new UserDataService();
          userDataService.saveData(response.userData);
        }

        if (
          !empty(response.trackingData) &&
          !empty(response.trackingData.label)
        ) {
          sendGAEvent(
            response.trackingData.category,
            response.trackingData.label,
            response.trackingData.action
          );
        }
      },
      error: response => {
        console.log(response);
        submitButton.classList.remove("loading");
        submitButton.disabled = false;
      }
    });

    return false;
  }

  _processResponse = (data) => {
    $(this.form)
      .parents(".contact-content")
      .empty()
      .append(data.htmlContent);

    initPopover();

    if (data.shouldInitVerifyPhoneForm) {
      this.eventBus.dispatch(EventName.InitVerifyPhoneNumberForm, null);
    }

    $(".contact-content .csn-control").each(function() {
      var $this = $(this);
      if ($this.val()) {
        $this
          .addClass("active")
          .next("label")
          .addClass("active");
      }
    });
  }

  _setupEventListener = () => {
    this.eventBus.handle(
      EventName.VerifyPhoneNumberResponded,
      this._processResponse
    );
  }

  _getBlockoInfo() {
    if (empty(userdata)) return null;
    let temporaryElementId = "getSellerPhoneNumberActionBlockoInfo";
    let blockoInput = $("<input id='" + temporaryElementId + "' />");
    $("body").append(blockoInput);
    userdata.p_data(temporaryElementId);
    let blockoValue = $("#" + temporaryElementId).val();
    blockoInput.remove();
    return blockoValue;
  }
}
